import { Component, computed, inject, Input } from '@angular/core';
import { toSignal } from '@angular/core/rxjs-interop';

import { type OfferFull } from '@core/offers-types';
import type { LayoutListRowComponent } from '@core/views-util';
import { StatusChangeFacade, StatusChangeDefaultFacade } from '@recruitee/offers-logic';
import { getJobRouterLink } from '@recruitee/offers-util';

import { ExtractOfferCountersPipe } from './offer-counters.pipe';
import { OffersListItemComponent } from './offers-list-item.component';
import { OfferCardFields } from './types';
import { JobsDataSourceService } from '../services/jobs-data-source.service';

@Component({
  selector: 'rt-offer-card-wrapper',
  imports: [ExtractOfferCountersPipe, OffersListItemComponent],
  template: `
    <rt-offers-list-item
      [isVisibleOnScreen]="true"
      [offer]="record"
      [counters]="record | extractOfferCounters: fieldsVisibilityMap"
      [detailsRouterLink]="jobRouterLink"
      [fieldsVisibilityMap]="fieldsVisibilityMap"
      [followLoading]="followLoading()"
      [canManageJobs]="canManageJobs()"
      [canViewAcquisition]="canViewAcquisition()"
      (offerToggleFollow)="onFollowToggle($event)"
    />
  `,
  providers: [{ provide: StatusChangeFacade, useClass: StatusChangeDefaultFacade }],
})
export class OfferListWrapperComponent implements LayoutListRowComponent<OfferFull> {
  private readonly jobsDataSourceService = inject(JobsDataSourceService);

  @Input() public record: LayoutListRowComponent<OfferFull>['record'];
  @Input() public fieldsVisibilityMap: Record<OfferCardFields, boolean>;

  protected canManageJobs = toSignal(this.jobsDataSourceService.canManageJobs$, {
    initialValue: false,
  });
  protected canViewAcquisition = toSignal(this.jobsDataSourceService.canViewAcquisition$, {
    initialValue: false,
  });
  protected followLoadingMap = toSignal(this.jobsDataSourceService.ongoingFollow, {
    initialValue: <Record<number, boolean>>{},
  });

  protected followLoading = computed(() => this.followLoadingMap()[this.record.id] ?? false);

  protected get jobRouterLink(): string[] {
    return getJobRouterLink(this.record);
  }

  protected onFollowToggle({
    followed,
    id,
    slug,
  }: {
    followed: boolean;
    id: number;
    slug: string;
  }) {
    this.jobsDataSourceService.toggleOfferFollow({ followed, id, slug });
  }
}
